// Image dimensions utility
// Returns width and height for specified image paths

export function getImageDimensions(imagePath: string): { width: number; height: number } | undefined {
  // Common image dimensions based on image paths
  const dimensions: Record<string, { width: number; height: number }> = {
    '/images/logo_siyah.webp': { width: 200, height: 60 },
    '/images/logo_beyaz.webp': { width: 200, height: 60 },
    '/images/logo_band_colored@3x.webp': { width: 200, height: 60 },
    '/images/samed-ordueri.jpeg': { width: 400, height: 400 },
    '/images/sepet-odeme-gorsel.webp': { width: 1200, height: 800 },
    '/images/blog1.webp': { width: 1200, height: 600 },
    '/images/metabusiness-thinklyze.webp': { width: 1200, height: 600 },
    '/images/google-thinklyze.jpg': { width: 1200, height: 600 },
    '/images/favicon-thinklyze.svg': { width: 32, height: 32 },
  }

  // Check for brand logos
  if (imagePath.includes('/images/brands/')) {
    return { width: 140, height: 80 }
  }

  // Check for portfolio images
  if (imagePath.includes('/images/portfolio/')) {
    return { width: 800, height: 600 }
  }

  // Check for blog images
  if (imagePath.includes('/images/blog/')) {
    return { width: 1200, height: 600 }
  }

  // Check for team images
  if (imagePath.includes('/images/team/')) {
    return { width: 400, height: 400 }
  }

  // Return dimensions if found, otherwise return undefined
  return dimensions[imagePath]
}

